import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  EquipmentsService
} from '../../../shared';

@Component({
  selector: 'app-equipments-new',
  templateUrl: './equipments-new.component.html',
  styleUrls: ['./equipments-new.component.scss']
})
export class EquipmentsNewComponent implements OnInit {
  title = "NOVO EQUIPAMENTO";
  subtitle = "Utilize os campos abaixo para cadastrar um novo equipamento";
  urlBack = "/panel/equipments/list";

  newEquipment = new FormGroup({
    dsProduto: new FormControl('', Validators.required),
    vlProduto: new FormControl(0, Validators.required),
    cdsProdutoSapAtivo: new FormControl('', Validators.required),
    cdsProdutoSapDespesa: new FormControl('', Validators.required),
    cdProdutoMarca: new FormControl('', Validators.required),
    cdProdutoModelo: new FormControl('', Validators.required),
    cdTpProduto: new FormControl('', Validators.required),
    cdsUnidadeSap: new FormControl('', [Validators.required, Validators.max(3)])
  });

  brandSelected = "";
  modelSelected = "";

  constructor(
    private headerService: HeaderService,
    private equipmentsService: EquipmentsService,
    private loadingBarService: LoadingBarService,
    private router: Router
  ) { }

  ngOnInit() {
    this.headerService.changeTitle('Cadastro de novo equipamento');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);
  }

  brand(obj) {
    this.newEquipment.patchValue({
      cdProdutoMarca: obj.id
    });

    this.brandSelected = JSON.stringify(obj);
  }

  model(obj) {
    this.newEquipment.patchValue({
      cdProdutoModelo: obj.id
    });

    this.modelSelected = JSON.stringify(obj);
  }

  addNewEquipment() {
    this.loadingBarService.start();

    this.equipmentsService.addEquipment(this.newEquipment.value).subscribe((response) => {
      this.loadingBarService.complete();

      this.newEquipment.reset();

      this.newEquipment.patchValue({
        vlProduto: 0
      });

      this.brandSelected = "";
      this.modelSelected = "";

      Swal({
        type: "success",
        title: "Equipamento cadastrado",
        text: "O equipamento será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      });
    });
  }

}
